// extracted by mini-css-extract-plugin
export default {"root":"TopBar__root___gJfOS","actions":"TopBar__actions___q32LJ","backlink":"TopBar__backlink___OWa0K","backlinkIcon":"TopBar__backlinkIcon___QQE_0"};